import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { fetchData } from "../../Cpanel/Components/Utilities";
import SimplePlan from "../Components/Plans/SimplePlan";
import { GoldPlan } from "../Components/Plans/GoldPlan";
import { InsuranceState } from "../Components/Plans/InsuranceState";
import Helmet from "../Components/Helment";

export const Plans = () => {
  const [userStatus, setUserStatus] = useState("");
  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    fetchData("guid", bodyFormData, handleApiResponse);
  }, []);
  const handleApiResponse = (data) => {
    setUserStatus(data?.userinfo?.grade);
  };

  return (
    <Helmet title="طرح های عضویت">
      <div className="mt-5 pt-5 px-4">
        <div className="card px-3 wd-75 wm-100 m-auto">
          <div className="card-body ">
            <p className="fs-4 fw-bold text-center">طرح های عضویت</p>
            <hr />
            <div className="overflow-x-auto ">
              {userStatus === 0 && <SimplePlan />}
              {userStatus === 1 && <GoldPlan />}
              {userStatus === 2 && <InsuranceState />}
            </div>
          </div>
        </div>
      </div>
    </Helmet>
  );
};
